import { render, staticRenderFns } from "./MailingTemplateForm.vue?vue&type=template&id=aac786f6&scoped=true&"
import script from "./MailingTemplateForm.vue?vue&type=script&lang=js&"
export * from "./MailingTemplateForm.vue?vue&type=script&lang=js&"
import style0 from "./MailingTemplateForm.vue?vue&type=style&index=0&id=aac786f6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aac786f6",
  null
  
)

export default component.exports